import { SkeletonLoader } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { SkeletonRow } from './styles'

export const SupplierListItemSkeleton = (): ReactElement => (
  <SkeletonRow data-testid="supplier-list-item-skeleton">
    <SkeletonLoader height={20} width="100%" />
  </SkeletonRow>
)
